<div class="filter-group-wrapper">
  <div class="page-filter-expandable">
    <button
      class="filter-toggle-btn"
      [class.active-filters]="hasActiveFilters"
      (click)="toggleFilter()"
    >
      <span>{{ label }}</span>
      @if (hasActiveFilters) {
        <span class="filter-indicator"></span>
      }
      <app-svg-icon
        [iconName]="'next.svg'"
        [height]="'12px'"
        [width]="'12px'"
        [class.expanded]="isOpen"
      ></app-svg-icon>
    </button>

    @if (isOpen) {
      <div class="filter-panel" (appClickOutside)="closeFilter()">
        <ng-content></ng-content>
      </div>
    }
  </div>

  @if (activeFilters.length > 0) {
    <div class="active-filters-list">
      @for (filter of activeFilters; track filter.type) {
        <div class="filter-badge">
          <span class="filter-label">{{ filter.label }}:</span>
          <span class="filter-value">{{ filter.displayValue }}</span>
          <button class="remove-filter-btn" (click)="removeFilter(filter)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      }
    </div>
  }
</div>
